export default __webpack_public_path__ + "static/media/304.56c95a46.gif";